import { Activity, FunctionComponent, memo } from 'react';
import classNames from 'classnames';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { Speaker } from '@/types/speakers.types';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import getCastInviteStatus from '@/micros/edit-project/grid-areas/main/cast-and-crew/components/cast-content/helpers/use-cast-select-invite-status';
import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { selectGreenroomSessionMeetings } from '@/store/slices/project/selectors';
import { resizedImage } from '@/utils/resized-image';

import styles from './render-unfocused-label-content.module.css';

type CustomRenderProps = FunctionComponent<{
  option: TReactSelectOption;
  idx: number;
  sessionUuid: string | undefined;
  chipsAsOptions?: boolean;
}>;

const RenderUnfocusedLabelContent: CustomRenderProps = memo(({ option, sessionUuid, chipsAsOptions }) => {
  const speaker = option.meta as Speaker;
  const activeChannel = useAppSelector(getActiveChannel);
  const meetings = useAppSelector(selectGreenroomSessionMeetings);
  const sessionMeetingData = sessionUuid ? meetings?.[sessionUuid] || null : null;
  const status = getCastInviteStatus({ speaker, activeChannel, sessionMeetingData });
  return (
    <div
      className={classNames('flex ai-center gap-8', {
        [styles.chip]: chipsAsOptions,
        'height-100-percent': !chipsAsOptions,
      })}
    >
      <div className="square-24 radius-6 position-relative">
        <img
          style={{ backgroundColor: 'var(--BG)' }}
          className="radius-6 image-cover"
          height={24}
          width={24}
          src={resizedImage(speaker.image, { height: 44, width: 44, fit: 'cover' })}
        />{' '}
        <Activity mode={status === 'Invite sent' ? 'visible' : 'hidden'}>
          <div
            className="position-absolute radius-full flex ai-center pc-center square-14"
            style={{
              top: 'calc(100% - 8px)',
              left: 'calc(100% - 8px)',
              background: 'var(--primitives-mode-1-orange-500)',
              border: '1px solid var(--BG)',
            }}
          >
            <Icon name={ICONS.SEND_3} size={8} color="var(--BG)" />
          </div>
        </Activity>
      </div>
      <Text clamp={1} className="S3" wordBreak="break-all">
        {speaker.first_name} {speaker.last_name}
      </Text>{' '}
    </div>
  );
});

RenderUnfocusedLabelContent.displayName = 'RenderUnfocusedLabelContent';

export default RenderUnfocusedLabelContent;
